import React from "react"
import Layout from "components/layout"
import SEO from "components/seo"
import { navigate } from "gatsby"

const plans = [
  {
    info: "For starters",
    title: "Pay As You Use per Month",
    benefits: [
      "50NGN per customer account.",
      "50Kobo per withdrawal",
      "2.50NGN per SMS",
      "25NGN per BVN Check",
      "25NGN per NIP transfer",
    ],
  },
  {
    info: "Test environment",
    title: "Custom",
    benefits: [
      "Pay a one time fee for setting you up",
      "We provide you with the support you need",
      "You pay a yearly license fee",
      "You are ready to scale!",
    ],
  },
]

const PricingPage = () => {
  return (
    <Layout active="pricing" bottomInfo={false}>
      <SEO title="Pricing" />
      <section>
        <div className="pt-32 pb-24 bg-snow-100 text-center">
          <h1 className="text-5xl font-bold shortFadeIn">
            Simple, fair pricing
          </h1>
          <p
            className="mt-5  w-11/12 lg:w-7/12 xl:w-5/12 mx-auto text-grey-200 text-sm shortFadeIn delay-300ms"
            style={{ lineHeight: "30px" }}
          >
            Harness the power of WoodCore SaaS banking application to seamlessly
            manage back office operations and orchestrate your finetech
            applications so your team can focus on customers and innovation.
          </p>
        </div>
      </section>

      <section>
        <div className="grid lg:grid-cols-2 gap-8 my-24 w-11/12 xl:w-10/12 mx-auto">
          {plans.map(plan => (
            <div className="w-full col-span-1">
              <div className="border border-grey-300 rounded-lg py-6 px-10  bg-snow-100 w-full h-full">
                <div>
                  <p className="text-grey-200 text-lg">{plan.info}</p>
                  <p className="text-4xl text-grey-100 font-semibold mt-2 mb-8">
                    {plan.title}
                  </p>
                  <hr className="border-t border-grey-300 my-4" />
                  <ul className="mt-5" style={{ minHeight: "320px" }}>
                    {plan.benefits.map(benefit => (
                      <li className="flex items-start mt-10">
                        <div className="mr-4">
                          <img
                            src={require("images/circle.svg")}
                            alt="circle svg"
                          />
                        </div>
                        <p className="text-sm text-grey-200 w-10/12">
                          {benefit}
                        </p>
                      </li>
                    ))}
                  </ul>
                  <div className="flex justify-center  mb-8">
                    <button
                      className="text-base text-white bg-green rounded-sm px-10 py-3 hover:bg-green-dark duration-500ms"
                      onClick={() => navigate("/contact")}
                    >
                      Select plan
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <div className="bg-dark py-24">
          <div className="w-11/12 xl:w-10/12 mx-auto md:flex justify-between items-center">
            <div>
              <h3 className="text-5xl text-white font-semibold xl:w-9/12">
                For custom pricing contact us
              </h3>
            </div>
            <div className="mt-10 md:mt-0">
              <button
                className="py-4 font-medium px-16 rounded-sm bg-green text-white text-lg hover:bg-green-dark duration-500ms"
                onClick={() => navigate("/contact")}
              >
                Select Plan
              </button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default PricingPage
